import { envConfig } from "@env/env-config";
export class StateFlowRestService {

    public static readonly $inject: string[] = ["$rest"];

    constructor(private $rest: qpmn.common.rest.IRestService) { }
    
    // 获取所有分支状态
    public getBranch(endityId: string): angular.IPromise<qpmn.common.rest.IRestResponse<Array<qpmn.common.model.domain.stateFlow.IStateInstanceDTO>>> {
        return this.$rest.http<Array<qpmn.common.model.domain.stateFlow.IStateInstanceDTO>>("stateFlowRestService", "getBranch", {
            endityId: endityId
        });
    }
    // 获取当前已流转分支状态
    public getBranched(endityId: string): angular.IPromise<qpmn.common.rest.IRestResponse<Array<qpmn.common.model.domain.stateFlow.IStateInstanceDetail>>> {
        return this.$rest.http<Array<qpmn.common.model.domain.stateFlow.IStateInstanceDetail>>("stateFlowRestService", "getBranched", {
            endityId: endityId
        });
    }
    /**
     * @description 取消
     *  */
    public cancel(endityId: string): angular.IPromise<qpmn.common.rest.IRestResponse<any>> {
        return this.$rest.http<any>("stateFlowRestService", "cancel", {
            endityId: endityId,
            actionKey: envConfig.ActionKey.cancelReturn
        });
    }
    /**
     * @description 提交快递信息
     * @param endityId：退货申请Id
     * @param actionKey：状态流转操作key
     * @param express：快递单号，快递配送公司
     *  */
    public submitExpress(endityId: string, express: qpmn.order.model.dto.IReturnRequestOrderExpressDto): angular.IPromise<qpmn.common.rest.IRestResponse<any>> {
        return this.$rest.http<any>("stateFlowRestService", "submitExpress", {
            endityId: endityId,
            actionKey: envConfig.ActionKey.expressAction,
            data: {
                number: express.number,
                provider: express.provider,
                returnRequestOrder: {
                    _id: endityId
                },
                clazz: "com.qpp.cgp.domain.salesreturn.ReturnRequestOrderExpress"
            }
        });
    }
    //  获取指定流程所有状态(退后申请)
    public getStateNodes(endityId: string): angular.IPromise<qpmn.common.rest.IRestResponse<Array<qpmn.common.model.domain.stateFlow.IState>>> {
        return this.$rest.http<any>("stateFlowRestService", "getStateNodes");
    }
    // TODO 待删除（审核通过）
    public affirm(endityId: string): angular.IPromise<qpmn.common.rest.IRestResponse<any>> {
        return this.$rest.http<any>("stateFlowRestService", "affirm", {
            endityId: endityId,
            actionKey: "REVIEW_APPROVE"
        });
    }
}